import { favouritesAxiosInstance as network } from '../../axios';
import { Endpoints, SiteTypes } from '../../enums';
import { FetchListsResponse } from '../../types';
import { endpointReplace } from '../../utils/endpointReplace';
import { getAuthenticationConfig } from '../../utils/getAuthenticationConfig';

export const getLists = async () => {
  const path = endpointReplace({ ':siteType': SiteTypes.FAVOURITES }, Endpoints.Lists);
  const authentication = await getAuthenticationConfig();

  const response = await network.get<FetchListsResponse>(path, authentication);

  return response.data.results;
};
